import api from "../api.service"

export function getNextFn(nextLink) {
    return () => {
        return api
            .get(`/v2/${nextLink.split("/v2/")[1]}`)
            .then((res) => getPaginatedResponse(res.data))
            .catch((err) => {
                throw api.getResponseError(err)
            })
    }
}

export function getPaginatedResponse(response) {
    return {
        ...response,
        getNext: response.nextLink ? getNextFn(response.nextLink) : () => Promise.resolve([]),
        hasNext: () => !!response.nextLink,
    }
}

export async function paginateAll(requestPromise, { signal } = {}) {
    if (signal?.aborted) {
        throw new Error("Aborted")
    }

    let response = await requestPromise
    let list = response.value

    while (response.hasNext()) {
        response = await response.getNext()
        list = [...list, ...response.value]
    }

    return list
}
